import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      [muiTheme.breakpoints.down('sm')]: {
        '&.MuiSnackbar-anchorOriginBottomCenter': {
          bottom: '40px !important',
        },
      },
      '& .MuiAlert-action': {
        alignItems: 'baseline',
        paddingTop: '4.5px',
      },
      '& .MuiAlert-standardSuccess': {
        maxHeight: '90vh',
        overflow: 'auto',
      },
    },
    alert: {},
    rootCentered: {
      '&.MuiSnackbar-root.MuiSnackbar-anchorOriginBottomCenter': {
        bottom: '50% !important',
        transform: 'translate(-50%,50%)',
        [muiTheme.breakpoints.down('sm')]: {
          transform: 'translate(0%,50%)',
        },
      },
    },

    message: {
      '& p': {
        margin: 0,
        padding: 0,
      },
    },
    overlay: {
      display: 'block',
      position: 'fixed',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      backgroundColor: 'rgba(14, 20, 27, 0.95) !important',
      zIndex: 1100,
    },
  }),
  { name: 'GenMessageBar' },
);

export default useStyles;
